import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSMobileDataGridAdvanced, { IOrderColumns } from "../../Components/DataGrid/WSMobileDataGridAdvanced";
import { callAPI, getLocalValue, IsSmallScreen, LoacalVariables, MasterPages, Method, updateMainHeader } from "../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { AllPermissions, getPermissions } from "../../commonFunctions/PermissionManger";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import ConfirmDialog, { useConfirmDialog } from "../../Components/Confirmation/ConfirmDialog";
import { resetDataComponent } from "../../StateManagement/actions";

export const TaskList: React.FC<any> = React.memo((props) => {
    AllPermissions.getInstance();
    const { add, edit, remove, view } = AllPermissions.getTaskPermission;
    const { showMessage } = useSnackbar();
    const dispatch = useDispatch()
    const {
        open,
        title,
        onConfirm,
        handleClose,
        openConfirmDialog,
    } = useConfirmDialog();
    const navigate = useNavigate();
    const isMobile = IsSmallScreen();
    useEffect(() => {
        updateMainHeader("Tasks");
        breadCrumbsStore.updateBreadCrumbs([
            { "Tasks": "" },
        ]);
    });

    let roleType = getLocalValue(LoacalVariables.RoleType);
    console.log('role type is', roleType)

    const source = {
        url: "tasks/search",
        page: 1,
        pageSize: 10,
        filter: roleType == 3 ? [] : [
            {
                field: "Lead.LeadOwner",
                operator: "eq",
                value: getLocalValue(LoacalVariables.UserId),
            },
        ],
        sort: [
            {
                field: "UpdatedAt",
                direction: "desc"
            }],
    };

    console.log("source", source);
    const handleDelete = async (id?: string | number) => {
        const response: any = await callAPI(`tasks`, Method.DELETE, null, id);
        dispatch(resetDataComponent('taskMainListGrid'));
        if (response?.success) {
            showMessage(response?.message, "success")
        }
        else {
            showMessage(response?.message || 'Something went wrong', "error")
        }
        handleClose()

    };
    /**
     * Edit function
     * @param action 
     * @param row 
     */
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {
            navigate(`/task/edit/${row?.id}`)
        }
        else if (action === "Delete") {
            openConfirmDialog("Delete this record?", () => handleDelete(row?.id))
        }
    };
    const columns: IColumns[] = [
        {
            header: "Task",
            fieldName: "taskName",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Task Date",
            fieldName: "customDate",
            type: 'date'
        },
        {
            header: "Task type",
            fieldName: "taskType",
            type: 'default'
        },
        {
            header: "Priority",
            fieldName: "priority",
            type: 'default'
        },

        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined, remove ? "Delete" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];

    const mobColumns: IOrderColumns[] = [
        {
            header: "Task",
            fieldName: "taskName",
            tooltip: true,
            type: 'default',
            labelSx: { fontWeight: 'bold' }
        },
        {
            header: "Task type",
            fieldName: "taskType",
            type: 'default'
        },
        {
            header: "Priority",
            fieldName: "priority",
            type: 'default',
            sm: 4,
        },
        {
            header: "Date",
            fieldName: "customDate",
            type: 'date',
            labelSx: { marginLeft: 2 },
            sm: 8,
            isBoderRadious: true
        },



        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];
    const handleClick = () => {
        navigate('/task/create')
    }
    return (
        <>
            <Grid container spacing={2}>
                {view ? <Grid item xs={12}>
                    {!isMobile && <WSDataGrid
                        id="taskMainListGrid"
                        title="Tasks"
                        columns={columns}
                        source={source}
                        addButton={{ label: 'New', color: 'secondary', }}
                        onAddButtonClick={handleClick}
                        gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
                    />
                    }
                    {isMobile &&
                        <WSMobileDataGridAdvanced title={'Tasks'} addButton={add ? { label: "New", color: "secondary" } : undefined}
                            onAddButtonClick={handleClick} columns={mobColumns} id="taskMainListGrid" source={source} />
                    }
                </Grid>
                    : <PermissionDenied />
                }
                <ConfirmDialog
                    open={open}
                    title={title}
                    onConfirm={onConfirm}
                    onClose={handleClose}
                />
            </Grid>
        </>
    )
})